export default {
  id: 5,
  pride: 3072,
  slug: "heart-world",
  series: "heart-world",
  category: "game",
  completeness: "partial",
  experienceable: true,
  status: "released",
  titleKey: {
    zh: "心界",
    en: "Heart World"
  },
  image: require('@/assets/images/hw_header_schinese.webp'),
  descriptionKey: {
    zh: "第一人称砍杀游戏，高考后寒假和大一上期间开发。本来想做成代表作，结果效果并不好，很希望能重制。不推荐游玩。",
    en: "First-person hack and slash game, developed after the college entrance exam through freshman year. Intended as a masterpiece but didn't turn out well. Hope to remake it. Not recommended for play."
  },
  date: { year: 2020, month: 12, day: 24 },
  genres: ["第一人称砍杀"],
  themes: ["心界探索"],
  engine: "虚幻引擎 4.24",
  platform: ["PC"],
  scale: {
    zh: "全流程 1 小时",
    en: "1 hour full playthrough"
  },
  achievements: [
    { zh: "Steam 销量 185 份", en: "185 copies sold on Steam" }
  ],
  developerNotesKey: {
    zh: "2020年上架，第一人称砍杀，做了半年的不成熟游戏，1刀售价，销量185。中位游玩时长7分钟。全游戏流程1小时。",
    en: "Released in 2020, a first-person hack-and-slash. An immature game made in half a year, priced at $1, sold 185 copies. Median playtime 7 minutes. Full playthrough about 1 hour."
  },
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "steam", url: "https://store.steampowered.com/app/1415580/Heart_World/", textKey: { zh: "Steam 商店", en: "Steam Store" } },
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1wp4y1B7bb/", textKey: { zh: "官方宣传片", en: "Official Trailer" } }
  ]
};
